export default {
  title: 'Articles',
  subtitle: 'News, guides, and updates from the PlayStock team.',
  loadFailed: "Couldn't load articles. Please try again.",
  emptyTitle: 'No articles yet',
  emptyBody: 'Check back soon for news and guides.',
  featured: 'Featured',
  readArticle: 'Read article',
  latest: 'Latest articles',
  readingMinutes: '{n} min read',
  read: 'Read',
  backToArticles: 'Back to articles',
  notFound: 'Article not found',
  shareThis: 'Share this article',
  copyLink: 'Copy link',
  linkCopied: 'Link copied',
};
